export interface SegmentSDKEventPayload {
    obj: {
        properties?: {
            journeyID?: string;
            isBot?: boolean;
            isE2E?: boolean;
            category?: string;
            products?: {
                product_id: string;
            }[];
            product_id?: string;
            pageName?: string;
        };
        messageId: string;
        event?: string; // Page view do not have it
        context: {
            traits?: { [key: string]: string };
        };
    };
}

export type SegmentSDKMiddleware = (props: {
    payload: SegmentSDKEventPayload;
    next: (x: SegmentSDKEventPayload) => void;
}) => void;

export interface SegmentTrackingConfig {
    journeyID: string;
    isBot: boolean;
    isE2E: boolean;
    deviceType: 'Mobile' | 'Tablet' | 'Desktop';
}
export interface SegmentSDK {
    track: (eventName: string, props?: Object, traits?: Object) => void;
    identify: (id: string | Object, props?: Object) => void;
    page: (category?: string | object, name?: string | object, properties?: object | null) => void;
    load: (key: string, props?: Object) => void;
    reset: () => void;
    setAnonymousId: (id: string) => void;
    initialized: boolean;
    addSourceMiddleware: (x: SegmentSDKMiddleware) => void;
    addDestinationMiddleware: (destination: string, x: SegmentSDKMiddleware) => void;
    user: () => {
        traits: () => { [key: string]: string };
    };
}

export interface SegmentTrackerInterface {
    track: (eventName: string, props?: Object | undefined) => void;
    trackFeatureViewed: (props?: Object | undefined) => void;
    trackExperimentViewed: (props?: Object | undefined) => void;
    trackFeatureInteracted: (props?: Object | undefined) => void;
    page: (category?: string | object, name?: string | object, properties?: object | null) => void;
    identify: (id: string, props?: Object | undefined) => void;
    reset: () => void;
    onConsentReceived: () => void;
    addCommonEventData: (data: SegmentPayload) => void;
}

export type SegmentPayload = NestedRecord<string | boolean> &
    Partial<Record<keyof SegmentSDKEventPayload['obj'], NestedRecord<string | boolean>>>;

interface NestedRecord<T> extends Record<string, T | NestedRecord<T>> {}

export type SegmentTracking = Pick<
    SegmentTrackerInterface,
    | 'track'
    | 'trackFeatureViewed'
    | 'trackFeatureInteracted'
    | 'trackExperimentViewed'
    | 'identify'
    | 'page'
    | 'reset'
    | 'addCommonEventData'
>;

export type MfSegmentTracking = Pick<SegmentTracking, 'page' | 'track' | 'addCommonEventData'>;

export const SEGMENT_EVENT_FEATURE_VIEWED = 'Feature Viewed';
export const SEGMENT_EVENT_FEATURE_INTERACTED = 'Feature Interacted';

export enum SegmentFeatureCategory {
    Overlay = 'Overlay',
    Banner = 'Banner',
    Slider = 'Slider',
}
export enum SegmentFeatureInteractionType {
    Click = 'Click',
    Close = 'Close',
}
